import { useState } from 'react';
import { Globe } from 'lucide-react';

const LanguageSelector = ({ onLanguageChange, currentLanguage = 'es' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'ca', label: 'Català' },
    { code: 'es', label: 'Español' }
  ];

  const handleSelect = (lang) => {
    onLanguageChange(lang);
    setIsOpen(false);
  };

  const current = languages.find(l => l.code === currentLanguage) || languages[1];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 rounded-full glass border border-slate-400/20 hover:border-slate-400/40 transition-all"
      >
        <Globe className="w-4 h-4 text-slate-300" />
        <span className="text-sm font-medium text-slate-300">{current.label}</span>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 glass rounded-xl border border-slate-400/20 overflow-hidden z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              className={`w-full px-4 py-3 text-left hover:bg-slate-400/10 transition-all ${
                lang.code === currentLanguage ? 'bg-slate-400/5' : ''
              }`}
            >
              <span className="text-sm text-gray-300">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
